<div class="example-container" [class.showMatGridLines]="sharedService.showMatGridLines"
  [class.mentorage-navigation-active]="isGuideNavigationStep"
  [class.sidenav-collapsed]="isSidenavCollapsed">
  <div class="desktop-layout">
    <aside class="sidenav-panel">
      <div class="example-sidenav">
        <div class="sidenav-content">
          <div class="user-section-wrapper">
            <user-section-sidenav [userData]="loggedUser" [collapsed]="isSidenavCollapsed"></user-section-sidenav>
          </div>

          <mat-divider class="profile-divider"></mat-divider>

          <mat-nav-list class="custom-nav-list" (scroll)="onTutorialSidebarScroll()">
            <ng-container *ngFor="let item of menuItems">
              <a #tutorialNavItem [routerLink]="isGuideNavigationStep ? undefined : item.routerLink || undefined"
                (click)="onMenuItemClick($event, item)"
                (keydown.enter)="isGuideNavigationStep ? onMenuItemClick($event, item) : null"
                (keydown.space)="isGuideNavigationStep ? onMenuItemClick($event, item) : null"
                [attr.role]="isGuideNavigationStep ? 'button' : null"
                [class.mentorage-navigation-target]="isGuideNavigationStep && item.id === guide.navigationMenuItemId"
                [attr.tabindex]="isGuideNavigationStep ? (item.id === guide.navigationMenuItemId ? 0 : -1) : null"
                class="nav-link" [title]="'SIDENAV.ITEMS.'+item.label | translate">
                <mat-list-item class="modern-item" [ngClass]="{'active-item': selectedItem === item.id}">
                  <span matListItemIcon class="icon-container">
                    @if (item.isSvgIcon) {
                    <mat-icon [svgIcon]="item.icon"></mat-icon>
                    } @else {
                    <mat-icon>{{item.icon}}</mat-icon>
                    }
                  </span>

                  <span matListItemTitle class="label-text" *ngIf="!isSidenavCollapsed">
                    {{'SIDENAV.ITEMS.'+item.label | translate}}
                  </span>

                  <div class="active-indicator" *ngIf="selectedItem === item.id"></div>
                </mat-list-item>
              </a>

              <mat-divider *ngIf="item.id === 'developerSettings'" class="menu-divider"></mat-divider>
            </ng-container>
          </mat-nav-list>

          <div class="sidenav-bottom">
            <div class="version-footer" *ngIf="!isSidenavCollapsed">
              <p>Versione: {{environment.short_env}}_{{environment.appVersion}}</p>
            </div>

            <button type="button" class="collapse-toggle" (click)="toggleSidenavCollapsed()"
              [attr.aria-label]="isSidenavCollapsed ? 'Apri menu laterale' : 'Chiudi menu laterale'"
              [title]="isSidenavCollapsed ? 'Apri menu' : 'Chiudi menu'">
              <mat-icon>{{isSidenavCollapsed ? 'chevron_right' : 'chevron_left'}}</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </aside>

    <main class="content-tile" [attr.inert]="isGuideNavigationStep ? '' : null">
      <ion-content [fullscreen]="true" [scrollY]="false">
        <app-monitoring-outlet></app-monitoring-outlet>
      </ion-content>
    </main>
  </div>

  @if (tutorialActive && currentTutorialItem) {
  <div class="desktop-tutorial-backdrop" [class.mentorage-navigation-backdrop]="isGuideNavigationStep" aria-hidden="true"></div>
  @if (tutorialSpotlight; as spotlight) {
  <div class="desktop-tutorial-spotlight" aria-hidden="true"
    [style.top.px]="spotlight.top"
    [style.left.px]="spotlight.left"
    [style.width.px]="spotlight.width"
    [style.height.px]="spotlight.height"></div>
  }

  <section #tutorialCardElement appTutorialScrollLock class="desktop-tutorial-card"
    [class.desktop-tutorial-card-positioned]="!!tutorialCardPosition"
    [style.top.px]="tutorialCardPosition?.top"
    [style.left.px]="tutorialCardPosition?.left"
    role="dialog" aria-modal="true" aria-live="polite">
    <button type="button" class="desktop-tutorial-skip" (click)="skipTutorial()">
      {{'DESKTOP_TUTORIAL.BUTTONS.SKIP' | translate}}
    </button>
    @if (isGuideNavigationStep) {
    <span class="desktop-tutorial-progress">{{'MOBILE_TUTORIAL.PROGRESS' | translate: { current: 1, total: guide.navigationTotal } }}</span>
    <h2>{{(guide.navigationTranslationKey + '.TITLE') | translate}}</h2>
    <p>{{(guide.navigationTranslationKey + '.DESKTOP') | translate}}</p>
    } @else {
    <span class="desktop-tutorial-progress">
      {{'DESKTOP_TUTORIAL.PROGRESS' | translate: { current: tutorialStepIndex + 1, total: tutorialMenuItems.length } }}
    </span>
    <h2>{{'SIDENAV.ITEMS.' + currentTutorialItem.label | translate}}</h2>
    <p>{{'DESKTOP_TUTORIAL.ITEMS.' + currentTutorialItem.id.toUpperCase() | translate}}</p>
    <div class="desktop-tutorial-actions">
      <button type="button" class="desktop-tutorial-secondary" (click)="previousTutorialStep()"
        [disabled]="tutorialStepIndex === 0">
        {{'DESKTOP_TUTORIAL.BUTTONS.BACK' | translate}}
      </button>
      <button type="button" class="desktop-tutorial-primary" (click)="nextTutorialStep()">
        {{tutorialPrimaryButtonKey | translate}}
      </button>
    </div>
    }
  </section>
  }
</div>
@defer (when guide.activeModule === 'history' || guide.activeModule === 'settings') {
<app-guide-tour></app-guide-tour>
}
